import React from "react";
import { ArrowRight, Scale } from "lucide-react";

const HERO_IMAGE = "https://images.unsplash.com/photo-1521587760476-6c12a4b040da?w=2400&q=80&auto=format&fit=crop";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative overflow-hidden"
      style={{ backgroundColor: "#0A1128" }}
    >
      <img
        src={HERO_IMAGE}
        alt="Classical law library with leather-bound legal volumes — the Chamber of Sikdar & Sikdar, Advocates, Chennai"
        className="absolute inset-0 w-full h-full object-cover"
        style={{ objectPosition: "center" }}
        loading="eager"
      />
      <div className="absolute inset-0 hero-overlay" />

      <div className="relative container-x flex flex-col justify-center min-h-[80vh] md:min-h-[92vh]">
        <div className="max-w-3xl py-20 md:py-32">
          <div className="flex items-center gap-3 mb-6 md:mb-8 fade-rise" style={{ color: "#C5A059" }}>
            <Scale size={16} strokeWidth={1.5} />
            <span className="text-[10px] md:text-xs uppercase" style={{ letterSpacing: "0.24em" }}>
              Boutique Litigation &amp; Advisory Chamber
            </span>
          </div>

          <h1
            className="font-serif-display text-[2.75rem] leading-[1.05] sm:text-5xl md:text-7xl md:leading-[1.02] fade-rise fade-rise-d1"
            style={{ color: "#F9F6F0", fontWeight: 500, letterSpacing: "-0.01em" }}
          >
            Sikdar &amp; Sikdar,
            <br />
            <span style={{ color: "#C5A059", fontStyle: "italic" }}>Advocates</span>
          </h1>

          <p
            className="mt-5 md:mt-6 text-[10px] md:text-[11px] uppercase fade-rise fade-rise-d2"
            style={{ color: "rgba(249,246,240,0.7)", letterSpacing: "0.28em" }}
          >
            M.K. Sikdar &nbsp;·&nbsp; Kirti Sikdar
          </p>

          <p
            className="mt-6 md:mt-8 max-w-xl text-base md:text-xl fade-rise fade-rise-d2"
            style={{ color: "rgba(249,246,240,0.85)", lineHeight: 1.6 }}
          >
            Over three decades of collective experience — seasoned advocacy paired
            with a modern, research-driven approach to civil, commercial,
            constitutional, property, family, service, consumer and regulatory
            matters.
          </p>

          <div className="mt-8 md:mt-12 flex flex-wrap items-center gap-3 fade-rise fade-rise-d3">
            <a href="#contact" className="btn-primary" data-testid="hero-cta-consult"
              style={{ backgroundColor: "#C5A059", borderColor: "#C5A059", color: "#0A1128" }}
            >
              Request a Consultation
              <ArrowRight size={14} strokeWidth={2} />
            </a>
            <a href="#practice" className="btn-ghost-light" data-testid="hero-cta-practice">
              Areas of Practice
            </a>
          </div>

          <div className="mt-12 md:mt-20 grid grid-cols-3 gap-4 md:gap-8 max-w-lg fade-rise fade-rise-d4">
            <Stat value="27+" label="Years at the Bar" />
            <Stat value="03" label="High Courts" />
            <Stat value="AFT" label="Chennai &amp; beyond" />
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-0 right-0 hidden md:flex justify-center">
        <span className="text-[10px] uppercase" style={{ color: "rgba(249,246,240,0.5)", letterSpacing: "0.32em" }}>
          Scroll
        </span>
      </div>
    </section>
  );
}

function Stat({ value, label }) {
  return (
    <div>
      <div className="font-serif-display text-3xl md:text-4xl" style={{ color: "#F9F6F0" }}>{value}</div>
      <div className="mt-2 text-[9px] md:text-[10px] uppercase" style={{ color: "rgba(249,246,240,0.6)", letterSpacing: "0.18em" }}>
        {label}
      </div>
    </div>
  );
}
